<button (click)="getData()">click me!</button>
<p>{{jsonData | json}}</p>